import React, { useEffect, useMemo, useState } from "react";

import {
    Delete as DeleteIcon,
    Edit as EditIcon,
    Add as AddIcon,
    AspectRatio as SizeIcon,
    Palette as PaletteIcon,
    TrendingUp,
} from "@material-ui/icons";

import DataTable from "../../../../components/data-table";
import FormModalContent from "./form";
import ConfirmModalContent from "../../../../components/confirm-modal-content";
import PageBuilderRowService from "../../../../services/page-builder-row.service";
import PageRowContentModal from "./contents";
import SelectGlassModal from "./contents/selectGalss";
import ChangeSort from "./changeSort";
import SelectBrandModal from "./contents/selectBrand";

const defaultKeys = [
    {
        title: "نام",
        field: "title",
    },
];

export default function PageRowsPage(props) {
    const { data, extra } = props;

    const [rows, setRows] = useState([]);

    const deleteItem = (item) => {
        return PageBuilderRowService.deletePageBuilderRow(item.id);
    };

    const headerCells = useMemo(
        () => [
            {
                field: "title",
                title: "عنوان",
                mainField: false,
            },
            {
                field: "showType",
                title: "مدل",
            },
        ],
        []
    );

    const onRefresh = async () => {
        const { data, error } = await PageBuilderRowService.getPageBuilderRow(props.data.id);
        if (error || !data) {
            return;
        }
        setRows(data.map(item => ({
            ...item,
        })));
    };

    useEffect(() => {
        onRefresh();
    }, []);

    return (
        <div className="p-3">
            <DataTable
                order={{order: "ASC", orderBy: "order"}}
                headCells={headerCells}
                data={rows}
                onRefresh={onRefresh}
                rowActions={[
                    {
                        modalProps: { maxWidth: "sm" },
                        icon: <PaletteIcon />,
                        modalProps: { fullScreen: true },
                        hidden: (data) => ["selectBrands", "selectGlasses"].includes(data.showType),
                        modalContent: (props) => <PageRowContentModal {...props} page={data} onRefresh={onRefresh} />,
                    },
                    {
                        modalProps: { maxWidth: "sm" },
                        icon: <PaletteIcon />,
                        modalProps: { fullScreen: false },
                        hidden: (data) => data.showType !== "selectBrands",
                        modalContent: (props) => <SelectBrandModal {...props} page={data} />,
                    },
                    {
                        modalProps: { maxWidth: "sm" },
                        icon: <PaletteIcon />,
                        modalProps: { fullScreen: false },
                        hidden: (data) => data.showType !== "selectGlasses",
                        modalContent: (props) => <SelectGlassModal {...props} page={data} />,
                    },
                    {
                        modalProps: { maxWidth: "md" },
                        icon: <EditIcon />,
                        modalContent: (p) => <FormModalContent {...p} parent={data} extra={extra} />,
                    },
                    {
                        modalProps: { maxWidth: "sm" },
                        icon: <TrendingUp />,
                        modalContent: (props) => <ChangeSort {...props} allData={rows}/>,
                    },
                    {
                        modalProps: { maxWidth: "sm" },
                        icon: <DeleteIcon />,
                        modalContent: (props) => (
                            <ConfirmModalContent
                                onConfirm={() => deleteItem(props.data)}
                                confirmText={props.data.name}
                                close={props.close}
                            />
                        ),
                    },
                ]}
                actions={[
                    {
                        modalProps: { maxWidth: "md" },
                        icon: <AddIcon />,
                        tooltip: "ایجاد ردیف",
                        modalContent: (p) => (
                            <FormModalContent {...p} parent={data} extra={extra} />
                        ),
                    },
                ]}
                searchKeys={defaultKeys}
                title={`ردیف های صفحه  "${data.title}"`}
            />
        </div>
    );
}
